import React from 'react';
import {useTranslation} from 'react-i18next';
import {Icon} from '@iconify/react';
import EngIcon from '../../assets/icons/lang/EN.svg?react';
import HrIcon from '../../assets/icons/lang/HR.svg?react';
import i18n from '../../../i18n';
import './languageSelector.scss';

export const LANGS = [
    {
        value: 'hr',
        flag: 'emojione:flag-for-croatia',
        icon: <HrIcon />,
    },
    {
        value: 'en',
        flag: 'emojione:flag-for-united-kingdom',
        icon: <EngIcon />,
    },
] as const;

const LANGUAGE_SELECTOR_LABEL: Record<(typeof LANGS)[number]['value'], 'header.languageSelector.hr' | 'header.languageSelector.en'> = {
    hr: 'header.languageSelector.hr',
    en: 'header.languageSelector.en',
};

interface LanguageSelectorProps {
    onSelect?: () => void;
    mobile?: boolean;
}

function LanguageSelector({onSelect, mobile}: LanguageSelectorProps): JSX.Element {
    const {t} = useTranslation();

    const selectedLang = LANGS.find((lang) => lang.value === i18n.language);

    const handleLanguageChange = (e: React.MouseEvent<HTMLButtonElement>): void => {
        i18n.changeLanguage(e.currentTarget.value);
        onSelect && onSelect();
    };

    return (
        <nav className={`c-languageSelector ${mobile ? 'c-languageSelector--mobile' : ''}`}>
            {LANGS.map((lang, index) => {
                return (
                    <button
                        type="button"
                        className={`c-languageSelector__item 
                            ${selectedLang?.value === lang.value ? 'c-languageSelector__item--selected' : ''}`}
                        value={lang.value}
                        key={`lang-${lang.value}-${index}`}
                        onClick={handleLanguageChange}
                    >
                        <Icon className="c-languageSelector__item_icon" icon={lang.flag} />
                        <div className="c-languageSelector__item_label">{t(LANGUAGE_SELECTOR_LABEL[lang.value])}</div>
                    </button>
                );
            })}
        </nav>
    );
}

export default LanguageSelector;
